import './instagram_content.js.coffee'
Monitoring.Models.SocialContents ||= {}

class Monitoring.Models.SocialContents.InstagramListeningMediaContent extends Monitoring.Models.SocialContents.InstagramContent

  getType:->
    'instagram'

  getSubType:->
    sub_type = @data().sub_type
    sub_type = 'instagram_listening_media' unless sub_type
    sub_type

  getOrigin:->
    origin = @data().origin
    origin = 'instagram_listening_media' unless origin
    origin

  getGroupType:->
    'instagram'

  getMainText:->
    text = @data().caption
    text = text.split("#").join(" #")
    text

  userComment:->
    @getMainText()

  getAuthorName: ->
    'Annonymous User'

  getAuthorUsername:->


  username:->
    return 'ANNON'

  getAvatar:->
    window.image_path('anonymous.png')

  getCreatedAt:->
    Date.create(@data().created_at)

  likesCount:->
    @data().like_count

  apiEndpointImage:->
    if(@mostPopularListening())
      return window.image_path("icon.png")
    else
      return window.image_path("chronometer.png")

  commentsCount:->
    @data().comments_count

  permalink:->
    @data().permalink

  getContentUrl:->
    @permalink()

  mostPopularListening:->
    @listeningSource()=="MOST_POPULAR"

  listeningSource:->
    @data().listening_endpoint

  socialNetworkName:->
    'instagram-listening'

  videoUrl:->
    @mediaUrl() if @isVideo()

  imageUrl:->
    if @isCarousel()
      window.image_path('ig-default-carousel@2x.png')
    else
      @mediaUrl() if @isImage()

  mediaUrl:->
    @data().media_url

  hashtagName:->
    @data().hashtag.hashtagName

  isCarousel:->
    return @data().media_type == "CAROUSEL_ALBUM"

  isImage: ->
    return @data().media_type == "IMAGE"

  isVideo: ->
    return @data().media_type == "VIDEO"

  hasProfile:->
    false

  image: ->
    return '' unless @data().images?
    return @data().images.low_resolution.url

  fullImage: ->
    return '' unless @data().images?
    return @data().images.standard_resolution.url

  video: ->
    return '' unless @data().videos?
    return @data().videos.low_bandwidth

  content: ->
    return if @caption() then @getMainText() else ''

  getRootParentId: ->
    @numeric_id()
